document.addEventListener('DOMContentLoaded', () => {
  const searchInput = document.getElementById('Search-In-Modal');
  
  let productGrid = document.getElementById('product-grid');
  let isFallbackGrid = false;
  let mainContent = document.getElementById('MainContent') || document.querySelector('main');

  // NEW FALLBACK: Create a dynamic grid with proper Shopify classes and spacing
  if (!productGrid && mainContent) {
    productGrid = document.createElement('ul');
    productGrid.id = 'product-grid';
    productGrid.className = 'grid product-grid custom-fallback-spacing'; 
    productGrid.style.listStyle = 'none';
    
    // Inject bulletproof spacing rules just for these text pages
    if (!document.getElementById('fallback-grid-styles')) {
      const style = document.createElement('style');
      style.id = 'fallback-grid-styles';
      style.innerHTML = `
        .custom-fallback-spacing {
          width: 100% !important;
          max-width: none !important; 
          margin: 0 !important;
          padding: 0 2rem !important;
        }
        @media screen and (min-width: 990px) {
          .custom-fallback-spacing { 
            padding: 0 5rem !important; 
          }
        }
      `;
      document.head.appendChild(style);
    }

    mainContent.parentNode.insertBefore(productGrid, mainContent);
    isFallbackGrid = true;
  }

  if (productGrid && productGrid.tagName.toLowerCase() !== 'ul') {
    const ul = productGrid.querySelector('ul.grid');
    if (ul) productGrid = ul;
  }

  const searchForm = searchInput ? searchInput.closest('form') : null;

  const loadMoreContainer = document.querySelector('collection-load-more') || document.querySelector('.main-collection__load-more-container');
  const loadMorePlaceholder = document.createComment('infinite-scroll-placeholder');

  if (!searchInput || !productGrid) return;

  const originalGridHTML = productGrid.innerHTML;
  let debounceTimer;
  let currentController = null;

  // Intercepting the Enter key for Hard Redirects
  if (searchForm) {
    searchForm.addEventListener('submit', (event) => {
      event.preventDefault(); 
      const query = searchInput.value.trim();
      const lowerQuery = query.toLowerCase();
      
      if (query.length > 0) {
        if (lowerQuery.includes('stockist') || lowerQuery.includes('retailer')) {
          window.location.href = '/pages/about';
          return;
        }
        if (lowerQuery.includes('appointment') || lowerQuery.includes('visit') || lowerQuery.includes('san francisco') || lowerQuery.includes('booking') || ['shop', 'store', 'book'].includes(lowerQuery)) {
          window.location.href = '/pages/visit';
          return;
        }
        if (lowerQuery.includes('washing') || lowerQuery.includes('garment care') || lowerQuery.includes('dry clean') || ['wash', 'care'].includes(lowerQuery)) {
          window.location.href = '/pages/garment-care';
          return;
        }
        if (lowerQuery.includes('return') || lowerQuery.includes('exchange') || lowerQuery.includes('refund') || lowerQuery.includes('shipping') || ['order', 'ordering'].includes(lowerQuery)) {
          window.location.href = '/pages/ordering';
          return;
        }

window.location.href = `${window.Shopify.routes.root}search?q=${encodeURIComponent(query)}&type=product,article&options[prefix]=last`;      }
    });
  }

  searchInput.addEventListener('input', (event) => {
    if (window.innerWidth < 990) return; 

    const query = event.target.value.trim();
    clearTimeout(debounceTimer);

    if (currentController) {
      currentController.abort();
    }

    // NEW: Grab the static notes block we named at the bottom of the file
    const staticNotes = document.getElementById('static-search-notes');

    if (query.length === 0) {
      productGrid.innerHTML = originalGridHTML;
      productGrid.classList.remove('search-active-grid');
      
      // NEW: Bring the static notes back if they delete their search query
      if (staticNotes) staticNotes.style.display = 'block';
      
      if (isFallbackGrid && mainContent) mainContent.style.display = '';
      if (loadMoreContainer && !document.contains(loadMoreContainer)) {
        loadMorePlaceholder.replaceWith(loadMoreContainer);
      }
      return;
    }

    // NEW: Hide the static notes the exact millisecond they start typing
    if (staticNotes) staticNotes.style.display = 'none';

    if (loadMoreContainer && document.contains(loadMoreContainer)) {
      loadMoreContainer.replaceWith(loadMorePlaceholder);
    }

    debounceTimer = setTimeout(() => {
      fetchRealTimeResults(query);
    }, 150);
  });

  function fetchRealTimeResults(query) {
    currentController = new AbortController();
    const signal = currentController.signal;

    const urlProducts = `${window.Shopify.routes.root}search/suggest?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=10&resources[options][prefix]=last&resources[options][unavailable_products]=last&resources[options][fields]=title,body,product_type,variants.title,vendor,tag&section_id=custom-predictive-grid`;
    const urlArticles = `${window.Shopify.routes.root}search/suggest?q=${encodeURIComponent(query)}&resources[type]=article&resources[limit]=4&resources[options][prefix]=last&resources[options][fields]=title,body,tag&section_id=custom-predictive-grid`;

    Promise.all([
      fetch(urlProducts, { signal }).then((response) => response.text()),
      fetch(urlArticles, { signal }).then((response) => response.text())
    ])
      .then(([productsText, articlesText]) => {
        const parser = new DOMParser();
        const productsDoc = parser.parseFromString(productsText, 'text/html');
        const articlesDoc = parser.parseFromString(articlesText, 'text/html');
        
        const productsResults = productsDoc.querySelector('#shopify-section-custom-predictive-grid');
        const articlesResults = articlesDoc.querySelector('#shopify-section-custom-predictive-grid');

        // --- THE SANITIZER ---
        // Strip out Shopify's unformatted native empty states so they don't break our CSS grid
        function sanitizePredictiveHTML(container) {
          if (!container) return;
          const elements = container.querySelectorAll('li, div, p');
          elements.forEach(el => {
            const text = el.textContent.trim().toLowerCase();
            if (text === 'no results match your query.' || text === 'no results match your query' || text === 'no results found') {
              const wrapper = el.closest('li') || el;
              if (wrapper && wrapper.parentNode) {
                  wrapper.parentNode.removeChild(wrapper);
              }
            }
          });
        }

        sanitizePredictiveHTML(productsResults);
        sanitizePredictiveHTML(articlesResults);
        // ----------------------

        let finalHTML = '';
        const lowerQuery = query.toLowerCase();
        let blockProducts = false; 

        if (isFallbackGrid && mainContent) mainContent.style.display = 'none';

        // --- KEYWORD INTERCEPTS ---
        if (lowerQuery.includes('stockist') || lowerQuery.includes('retailer')) {
          finalHTML += `
            <li style="width: 100%; grid-column: 1 / -1; text-align: center; padding-bottom: 2rem; border-bottom: 1px solid rgba(0,0,0,0.1); margin-bottom: 2rem; list-style: none;">
              <p style="margin: 0; color: inherit;">visit our <a href="/pages/about" style="text-decoration: underline; color: inherit; text-underline-offset: 4px;">about page</a> for a full list of our stockists</p>
            </li>
          `;
          blockProducts = true; 
        } 
        else if (lowerQuery.includes('store') || lowerQuery.includes('appointment') || lowerQuery.includes('visit') || lowerQuery.includes('shop') || lowerQuery.includes('san francisco') || lowerQuery.includes('book') || lowerQuery.includes('booking')) {
          finalHTML += `
            <li style="width: 100%; grid-column: 1 / -1; text-align: center; padding-bottom: 2rem; border-bottom: 1px solid rgba(0,0,0,0.1); margin-bottom: 2rem; list-style: none;">
              <p style="margin: 0; color: inherit;">for store details and appointments, review our <a href="/pages/visit" style="text-decoration: underline; color: inherit; text-underline-offset: 4px;">visit page</a></p>
            </li>
          `;
        }
        else if (lowerQuery.includes('washing') || lowerQuery.includes('wash') || lowerQuery.includes('care') || lowerQuery.includes('garment care') || lowerQuery.includes('dry clean')) {
          finalHTML += `
            <li style="width: 100%; grid-column: 1 / -1; text-align: center; padding-bottom: 2rem; border-bottom: 1px solid rgba(0,0,0,0.1); margin-bottom: 2rem; list-style: none;">
              <p style="margin: 0; color: inherit;">for washing, drying, and general care advice, visit our <a href="/pages/garment-care" style="text-decoration: underline; color: inherit; text-underline-offset: 4px;">garment care page</a></p>
            </li>
          `;
        }
        else if (lowerQuery.includes('return') || lowerQuery.includes('exchange') || lowerQuery.includes('refund') || lowerQuery.includes('shipping') || lowerQuery.includes('order')) {
          finalHTML += `
            <li style="width: 100%; grid-column: 1 / -1; text-align: center; padding-bottom: 2rem; border-bottom: 1px solid rgba(0,0,0,0.1); margin-bottom: 2rem; list-style: none;">
              <p style="margin: 0; color: inherit;">for our returns, ordering, and shipping, visit our <a href="/pages/ordering" style="text-decoration: underline; color: inherit; text-underline-offset: 4px;">ordering guidelines page</a></p>
            </li>
          `;
          if (!lowerQuery.includes('order')) {
            blockProducts = true; 
          }
        }
        // --------------------------

        let pHTML = (productsResults && productsResults.innerHTML.trim() !== "") ? productsResults.innerHTML : "";
        let aHTML = (articlesResults && articlesResults.innerHTML.trim() !== "") ? articlesResults.innerHTML : "";
        
        let hasProducts = pHTML.length > 0;
        let hasArticles = aHTML.length > 0;
        let hasResults = false;

        if (!blockProducts) {
          if (!hasProducts && hasArticles) {
            // Products empty, but Articles exist. Stack the message centered, full width.
            finalHTML += `<li style="width: 100%; grid-column: 1 / -1; text-align: center; padding-bottom: 2rem; list-style: none;"><p style="margin: 0; color: inherit;">No products match your query.</p></li>`;
            finalHTML += aHTML;
            hasResults = true;
          } else if (hasProducts && !hasArticles) {
            finalHTML += pHTML;
            hasResults = true;
          } else if (hasProducts && hasArticles) {
            finalHTML += pHTML;
            finalHTML += aHTML;
            hasResults = true;
          }
        }

        // Catchall Final Output
        if (hasResults || finalHTML !== '') {
          productGrid.innerHTML = finalHTML;
          if (hasResults) {
             productGrid.classList.add('search-active-grid');
          } else {
             productGrid.classList.remove('search-active-grid');
          }
        } else {
          // Absolute zero results across the board
          productGrid.innerHTML = '<li style="width: 100%; grid-column: 1 / -1; text-align: center; padding: 4rem 0; list-style: none;"><p style="margin: 0; color: inherit;">No results match your query.</p></li>';
          productGrid.classList.remove('search-active-grid');
        }
      })
      .catch((error) => {
        if (error.name !== 'AbortError') {
          console.error('Error fetching search results:', error);
        }
      });
  }
});
// Search Page Layout Enforcer: Group Notes Below Products
document.addEventListener('DOMContentLoaded', () => {
  if (window.location.pathname.includes('/search')) {
    // Target the specific wrapper that controls the restricted page width
    const mainProductGridWrapper = document.querySelector('#product-grid');
    const articleItems = Array.from(document.querySelectorAll('.article-card')).map(card => card.closest('li'));
    
    if (articleItems.length > 0 && mainProductGridWrapper) {
      
      const notesSection = document.createElement('div');
      notesSection.id = 'static-search-notes'; // <-- NEW: Gives the static block a name
      notesSection.style.width = '100%';
      notesSection.style.marginTop = '6rem'; 
      notesSection.style.marginBottom = '2rem';
      
      notesSection.innerHTML = `
        <hr style="border: none; border-top: 1px solid rgba(0,0,0,0.04); margin: 0 0 3rem 0; width: 100%;">
        <p style="text-align: center; margin: 0 0 3rem 0; font-size: 0.9em; letter-spacing: 0.05em; color: inherit;">recommended notes</p>
        <ul class="custom-notes-grid"></ul>
      `;
      
      const notesGrid = notesSection.querySelector('.custom-notes-grid');
      
      articleItems.forEach(item => {
        item.className = ''; 
        notesGrid.appendChild(item);
      });
      
      // THE FIX: Append directly INSIDE the width-restricted wrapper, right below the products
      mainProductGridWrapper.appendChild(notesSection);
    }
  }
});